<template>
  <v-container max-width="100%" style="margin-top: 2%;">
    <template>
      <v-row justify="center">
        <v-dialog v-model="autorizacaoDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemAutorizacaoDialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="logout">
                {{ $t('button.logout') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-alert :type="this.tipoAlerta" timeout="5000" dismissible v-model="showAlert"
      style="margin-bottom: 35px; border-radius: 10px;">
      {{ this.mensagemAlerta }}
    </v-alert>

    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{ $t('button.dismiss')
                }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
                $t('button.confirm') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="documentosDialog" persistent max-width="80%" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <div>{{ $t('document.self') }}</div>
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headersDocumentos" :items="documentosFuncionario" sort-by="cod_tipo_documento"
                dense class="elevation-7" locale="pt" style="border-radius: 10px;">

                <template v-slot:top>
                  <v-toolbar flat color="white" style="border-radius: 10px;">
                    <v-spacer></v-spacer>
                    <v-dialog v-model="addDocDialog" max-width="100%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline" style="color: #4a4a4a">{{ formTitleDoc }}</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-form ref="formDoc" v-model="formDocValidado">
                              <v-row>
                                <v-col cols="12" sm="3">
                                  <v-select :items="tiposDocumentos" v-model="editedDoc.id_tipo_documento"
                                    item-text="cod_tipo_documento" item-value="id_tipo_documento"
                                    :disabled="tipoDocumentoDisabled" :label="$t('document.type') + ' *'"
                                    :rules="[(v) => !!v || $t('document.typeRequired')]"></v-select>
                                </v-col>
                                <v-col cols="12" sm="3">
                                  <v-select :items="statusDocumentos" v-model="editedDoc.id_status_documento"
                                    item-text="descricao_status_documento" item-value="id_status_documento"
                                    :label="$t('document.status') + ' *'"
                                    :rules="[(v) => !!v || $t('document.statusRequired')]"></v-select>
                                </v-col>
                                <v-col cols="12" sm="3">
                                  <v-menu ref="menu" v-model="menu" transition="scale-transition" offset-y
                                    min-width="auto" :close-on-content-click="false" :return-value.sync="dataVencimento"
                                    :rules="[validaCampo]">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field v-model="dataFormat" :label="$t('document.expiryDate')"
                                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="dataVencimento" no-title scrollable locale="pt"
                                      :min="today">
                                      <v-spacer></v-spacer>
                                      <v-btn text color="primary" @click="menu = false">{{ $t('button.cancel')
                                        }}</v-btn>
                                      <v-btn text color="primary" @click="$refs.menu.save(dataVencimento)">{{
                                        $t('button.confirm') }}</v-btn>
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="12" sm="3">
                                  <v-file-input show-size accept="image/png, image/jpeg, pdf"
                                    :label="$t('document.selectFile')" v-model="arquivoImg"
                                    @change="fileChanged"></v-file-input>
                                </v-col>
                              </v-row>
                            </v-form>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary darken-1" class="white--text" @click="closeDoc">
                            {{ $t('button.cancel') }}
                          </v-btn>
                          <v-btn color="primary darken-1" class="white--text" @click="saveDoc">
                            {{ $t('button.save') }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" color="blue" @click="downloadDocumento(item)"
                    :disabled="item.doc_uri === null">mdi-download</v-icon>
                  <v-icon small class="mr-2" color="green" @click="editDocumento(item)">mdi-pencil</v-icon>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="closeDocumentosDialog">{{ $t('button.close') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <ResultDialogZIP :show="zipResultDialog" :result="zipResult" :token="token" @close="closeZipResultDialog" />

    <merus-data-table :headers="headers" :items="funcionarios" :mostrar-inativos="mostrarInativos" :default-multi-sort="defaultSort"
      :loading-text="$t('employee.loading')" @update:displayedItems="displayedItemsForExport = $event"

 cod-tabela="FUNCIONARIOS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :token="token" :title="$t('employee.title')" :items="displayedItemsForExport !== null ? displayedItemsForExport : funcionariosFiltrados"
          :csv-title="$tc('employee.self', 1)" :csv-headers="headersCSV" :pdf-title="$t('employee.pdfTitle')"
          :pdf-headers="headers" :pdf-filename="$tc('employee.self', 1)" :help-dialog-csv-fields="csvFields"
          :help-dialog-csv-model="$tc('employee.self', 1)" :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvfuncionarios/' : null"
          hide-search @saveBulk="saveBulk">
          <template v-slot:extension>
            <v-switch
              v-model="mostrarInativos"
              :label="$t('crudVeiculos.showInactive')"
              class="ml-3 mr-4"
              hide-details
            ></v-switch>
            <UploadDialog :token="token" :title="$t('document.zip')" :endpoint="'/api/v1.0/insertdocumentopessoazip'" :user="user.id_usuario"
              fileType="zip" size="s" @done="handleDone" @error="handleError" />
          </template>
          <template v-slot:add v-if="canInsert">
            <v-dialog v-model="dialog" max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline" style="color: #4a4a4a">{{
                    formTitle
                    }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="12" sm="6" md="3">
                          <v-select v-model="editedItem.id_empresa" :items="empresas" item-text="razao_social"
                            item-value="id_empresa" single-line auto :label="$t('employee.headers.company') + ' *'"
                            :rules="[(v) => !!v || $t('employee.companyRequired')]"
                            :disabled="isEmpresaDisabled"
                            @change="onFuncionarioEmpresaChange"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-autocomplete v-model="editedItem.id_cliente" :items="clientesPorEmpresa(editedItem.id_empresa)"
                            item-text="nome_cliente" item-value="id_cliente" clearable
                            :label="$t('crudLinhas.form.fields.selectClient')"
                            :disabled="!editedItem.id_empresa || isClienteDisabled"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-select v-model="editedItem.categoria" :items="categorias" item-text="categoria_extenso"
                            item-value="id_categoria" auto :label="$t('employee.headers.category') + ' *'"
                            :rules="[(v) => !!v || $t('employee.categoryRequired')]"
                            :disabled="isCategoriaDisabled"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-select v-model="pais" :items="paises" item-text="nome" item-value="id_pais" auto :label="$t('employee.country') + ' *'"
                            :rules="[(v) => !!v || $t('employee.countryRequired')]" :disabled="isPaisDisabled"></v-select>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.cpf" :label="labelDocumentoIdentidade + ' *'"
                            :rules="[validaDocumentoIdentidade]" :disabled="isCPFDisabled"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.cnh" :label="$t('csv.fields.driverLicense.label')"
                            :rules="[validaCNH]" :disabled="isCNHDisabled"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.matricula"
                            :label="$t('csv.fields.registration.label') + ' *'"
                            :disabled="isMatriculaDisabled"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <LazySelect
                            ref="unidadeSelect"
                            get-url="getUnidadeslazy"
                            text="descricao_unidade"
                            value="id_unidade"
                            :label="$tc('unit.self', 1)"
                            @input="onUnidadeSelect"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="5" sm="5" md="4">
                          <v-text-field v-model="editedItem.nome" :label="$t('csv.fields.personName.label') + ' *'"
                            :rules="[(v) => !!v || $t('employee.nameRequired')]"
                            :disabled="isNomeDisabled"></v-text-field>
                        </v-col>
                        <v-col cols="5" sm="5" md="4">
                          <v-text-field v-model="editedItem.sobrenome"
                            :label="$t('csv.fields.personFamilyName.label') + ' *'"
                            :rules="[(v) => !!v || $t('employee.familyNameRequired')]"
                            :disabled="isSobrenomeDisabled"></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="1" md="1">
                          <v-switch v-model="isAtivo" class="ma-2" :label="$t('employee.headers.active')"></v-switch>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary darken-1" class="white--text" @click="close">{{ $t('button.cancel') }}
                  </v-btn>
                  <v-btn color="primary darken-1" class="white--text" @click="save">{{ $t('button.save') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </CadastroToolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="blue" @click="openDocumentosDialog(item)">mdi-file</v-icon>
        <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="!canDelete">mdi-delete</v-icon>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import { defaultCountry } from "@/constants"
import DateUtils from "../utils/dateutils";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import UploadDialog from "./Dialogs/UploadDialog.vue";
import ResultDialogZIP from "./Dialogs/ResultDialogZIP.vue";
import LazySelect from "./Selects/LazySelect.vue";
import curp from "curp";
import translateDbField from "@/utils/translateDbField";
import { getScopedClienteIdForCreate, shouldLockClienteOnCreate } from "@/utils/sessionCliente";

export default {
  data: () => ({
    search: "",
    user: null,
    token: null,
    mensagemAutorizacaoDialog: "",
    autorizacaoDialog: false,
    showConfirmButton: true,

    formValidado: true,
    showAlert: false,
    mensagemAlerta: "",
    mensagemUpload: "",
    tipoAlerta: "success",
    dialog: false,
    operacao: 0,
    isAtivo: true,
    confirmDialog: false,
    uploadDialog: false,
    zipResultDialog: false,
    zipResult: null,
    mensagemdialog: "",
    disableEmpresa: false,
    disableMatricula: false,
    disableNome: false,
    disableSobrenome: false,
    disableCPF: false,
    disableCNH: false,
    disableCliente: false,
    scopedClienteCreateLocked: false,
    isCategoriaDisabled: false,
    fileLoading: false,
    arquivoCsv: null,
    idempresaupload: null,
    fimProcesso: false,
    arquivoLog: null,
    helpDialog: false,
    isPaisDisabled: false,
    empresas: [],
    funcionarios: [],
    mostrarInativos: false,
    displayedItemsForExport: null,
    categorias: [],
    documentosFuncionario: [],
    documentosDialog: false,
    editedIndex: -1,
    editedItem: {
      id_funcionario: null,
      matricula: null,
      nome: null,
      categoria: null,
      id_empresa: null,
      id_cliente: null,
      id_unidade: null,
      razao_social: null,
      ativo: null,
      ativo_extenso: null,
      sobrenome: null,
      cpf: null,
      cnh: null,
      id_pais: null,
    },
    deletedItem: {
      id_funcionario: null,
      matricula: null,
      nome: null,
      categoria: null,
      id_empresa: null,
      id_cliente: null,
      id_unidade: null,
      razao_social: null,
      ativo: null,
      ativo_extenso: null,
      sobrenome: null,
      cpf: null,
      cnh: null,
      id_pais: null,
    },
    defaultItem: {
      id_funcionario: null,
      matricula: null,
      nome: null,
      categoria: null,
      id_empresa: null,
      id_cliente: null,
      id_unidade: null,
      razao_social: null,
      ativo: null,
      ativo_extenso: null,
      sobrenome: null,
      cpf: null,
      cnh: null,
      id_pais: null,
    },
    addDocDialog: false,
    formDocValidado: false,
    editedIndexDoc: -1,
    editedDoc: {
      id_funcionario: null,
      id_status_documento: null,
      id_tipo_documento: null,
      doc_uri: null,
      id_usuario_inclusao: null,
      id_usuario_ultima_alteracao: null,
      dt_inclusao: null,
      dt_inclusao_extenso: null,
      dt_ultima_alteracao: null,
      dt_ultima_alteracao_extenso: null,
      dt_vencimento: null,
      dt_vencimento_extenso: null,
      descricao_status_documento: null,
      cod_tipo_documento: null,
      usuario_inclusao: null,
      usuario_alteracao: null
    },
    defaultDoc: {
      id_funcionario: null,
      id_status_documento: null,
      id_tipo_documento: null,
      doc_uri: null,
      id_usuario_inclusao: null,
      id_usuario_ultima_alteracao: null,
      dt_inclusao: null,
      dt_inclusao_extenso: null,
      dt_ultima_alteracao: null,
      dt_ultima_alteracao_extenso: null,
      dt_vencimento: null,
      dt_vencimento_extenso: null,
      descricao_status_documento: null,
      cod_tipo_documento: null,
      usuario_inclusao: null,
      usuario_alteracao: null
    },
    menu: false,
    dataVencimento: null,
    arquivoImg: null,
    tiposDocumentos: [],
    statusDocumentos: [],
    docimg: null,
    recursos: [],
    empresasPermitidas: [],
    clientes: [],
    paises: [],
    pais: null,
    canInsert: false,
    canEdit: false,
    canDelete: false,
    headers: [],
  }),
  computed: {
    funcionariosFiltrados() {
      if (!this.mostrarInativos) {
        return this.funcionarios.filter((f) => f.ativo === true || f.ativo === 1);
      }
      return this.funcionarios;
    },
    headersDocumentos() {
      return [
        { text: this.$t('document.headers.id'), value: 'id_documento', align: ' d-none' },
        { text: this.$t('document.headers.type'), value: 'cod_tipo_documento' },
        { text: this.$t('document.headers.status'), value: 'descricao_status_documento' },
        { text: this.$t('document.headers.inclusionDate'), value: 'dt_inclusao_extenso' },
        { text: this.$t('document.headers.lastUpdate'), value: 'dt_ultima_alteracao_extenso' },
        { text: this.$t('document.headers.expiryDate'), value: 'dt_vencimento_extenso' },
        { text: this.$t('document.headers.actions'), value: 'actions', sortable: false }];
    },
    messageConfirmButton() {
      return this.$t('button.confirm');
    },
    messageDismissButton() {
      return this.$t('button.dismiss');
    },
    defaultSort() {
      return [
        { value: 'ativo_extenso', options: { text: this.$t('routs.decreasing'), value: -1 } },
        { value: 'nome_completo', options: { text: this.$t('routs.increasing'), value: 1 } }];
    },
    csvFields() {
      return [
        {
          label: this.$t('csv.fields.companyCode.label'),
          description: this.$t('csv.fields.companyCode.description'),
          example: this.$t('csv.fields.companyCode.example'),
          key: "cod_empresa"
        },
        {
          label: this.$t('csv.fields.clientCode.label'),
          description: this.$t('employee.csv.codClienteDescription'),
          example: this.$t('csv.fields.clientCode.example'),
          key: "cod_cliente"
        },
        {
          label: this.$t('csv.fields.registration.label'),
          description: this.$t('csv.fields.registration.description'),
          example: this.$t('csv.fields.registration.example'),
          key: "matricula"
        },
        {
          label: this.$t('csv.fields.personName.label'),
          description: this.$t('csv.fields.personName.description'),
          example: this.$t('csv.fields.personName.example'),
          key: "nome"
        },
        {
          label: this.$t('csv.fields.personFamilyName.label'),
          description: this.$t('csv.fields.personFamilyName.description'),
          example: this.$t('csv.fields.personFamilyName.example'),
          key: "sobrenome"
        },
        {
          label: this.$t('csv.fields.category.label'),
          description: this.$t('csv.fields.category.description'),
          example: this.$t('csv.fields.category.example'),
          key: "categoria"
        },
        {
          label: this.$t('csv.fields.cpf.label'),
          description: this.$t('csv.fields.cpf.description'),
          example: this.$t('csv.fields.cpf.example'),
          key: "cpf"
        },
        {
          label: this.$t('csv.fields.driverLicense.label'),
          description: this.$t('csv.fields.driverLicense.description'),
          example: this.$t('csv.fields.driverLicense.example'),
          key: "cnh"
        },
        {
          label: this.$t('csv.fields.integrationCode.label'),
          description: this.$t('csv.fields.integrationCode.description'),
          example: this.$t('csv.fields.integrationCode.example'),
          key: "cod_integracao_func"
        },
        {
          label: this.$t('csv.fields.country.label'),
          description: this.$t('csv.fields.country.description'),
          example: this.$t('csv.fields.country.example'),
          key: "cod_pais"
        },
        {
          label: this.$t('csv.fields.active.label'),
          description: this.$t('csv.fields.active.description'),
          example: this.$t('csv.fields.active.example'),
          key: "ativo"
        }];
    },
    headersCSV() {
      return [
        { text: this.$t('csv.lineNumber'), value: 'line_number', error: 'error_line' },
        { text: this.$t('crudVeiculos.csvHeaders.operacao'), value: "operacao" },
        { text: this.$t('csv.fields.companyCode.label'), value: 'cod_empresa', error: 'error_empresa' },
        { text: this.$t('csv.fields.clientCode.label'), value: 'cod_cliente', error: 'error_cliente' },
        { text: this.$t('csv.fields.registration.label'), value: 'matricula', error: 'error_matricula', warning: 'warning_matricula' },
        { text: this.$t('csv.fields.personName.label'), value: 'nome', error: 'error_nome' },
        { text: this.$t('csv.fields.personFamilyName.label'), value: 'sobrenome', error: 'error_sobrenome' },
        { text: this.$t('csv.fields.category.label'), value: 'categoria', error: 'error_categoria' },
        { text: this.$t('csv.fields.cpf.label'), value: 'cpf', error: 'error_cpf', warning: 'warning_cpf' },
        { text: this.$t('csv.fields.driverLicense.label'), value: 'cnh', error: 'error_cnh', warning: 'warning_cnh' },
        { text: this.$t('csv.fields.integrationCode.label'), value: 'cod_integracao', error: 'error_cod_integracao' },
        { text: this.$t('csv.fields.country.label'), value: 'pais', error: 'error_pais' },
        { text: this.$t('csv.fields.active.label'), value: 'ativo', error: 'error_ativo' }];
    },
    labelDocumentoIdentidade() {
      if (!this.pais) {
        return this.$t('csv.fields.cpf.label');
      }

      // Busca o país selecionado
      const paisSelecionado = this.paises.find(p => p.id_pais === this.pais);
      
      // Se o país for México (id_pais = 2 ou sigla = 'MX'), retorna CURP
      if (paisSelecionado && (paisSelecionado.id_pais === 2 || paisSelecionado.sigla === 'MX')) {
        return 'CURP';
      }
      
      // Para Brasil ou outros países, retorna CPF
      return 'CPF';
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('employee.register')
        : this.$t('employee.edit');
    },
    formTitleDoc() {
      return this.editedIndexDoc === -1
        ? this.$t('document.insert')
        : this.$t('document.edit');
    },
    isEmpresaDisabled() {
      return this.disableEmpresa || (this.editedIndex === -1 && this.scopedClienteCreateLocked);
    },
    isProcessFinished() {
      return this.fimProcesso;
    },
    isMatriculaDisabled() {
      return this.disableMatricula;
    },
    isNomeDisabled() {
      return this.disableNome;
    },
    isFileLoading() {
      return this.fileLoading;
    },
    isCPFDisabled() {
      return this.disableCPF;
    },
    isCNHDisabled() {
      return this.disableCNH;
    },
    isSobrenomeDisabled() {
      return this.disableSobrenome;
    },
    isClienteDisabled() {
      return this.disableCliente || (this.editedIndex === -1 && this.scopedClienteCreateLocked);
    },
    today() {
      return new Date().toISOString();
    },
    dataFormat() {
      if (!this.dataVencimento) return null;
      const [ano, mes, dia] = this.dataVencimento.split('-');
      return `${dia}/${mes}/${ano}`;
    },
    tipoDocumentoDisabled() {
      return this.editedIndexDoc !== -1;
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.editedIndex === -1) {
            this.applyScopedClienteEmpresaOnCreate();
            this.applySingleEmpresaIfOnlyOption();
          }
          this.syncUnidadeSelect();
        });
      }
      val || this.close();
    },
    clientes() {
      if (this.dialog && this.editedIndex === -1) {
        this.applyScopedClienteEmpresaOnCreate();
        this.applySingleEmpresaIfOnlyOption();
      }
    },
    empresas() {
      if (this.dialog && this.editedIndex === -1) {
        this.$nextTick(() => {
          this.applyScopedClienteEmpresaOnCreate();
          this.applySingleEmpresaIfOnlyOption();
        });
      }
    },
    pais(val) {
      this.paisAlterado(val);
      // Revalidate CPF/CURP field when country changes
      if (this.$refs.form && this.editedItem.cpf) {
        this.$nextTick(() => {
          this.$refs.form.validate();
        });
      }
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  mounted() {
    this.$root.$emit('eventshowback', true);
  },
  methods: {

    paisAlterado(val) {
      if (val) {
        this.editedItem.id_pais = val;
        // Clear CPF/CURP field when country changes to force re-validation
        // this.editedItem.cpf = null;
      }
    },
    validaCampo() {
      return true;
    },
    logout() {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("api");
      var id = window.setTimeout(function () { }, 0);
      while (id--) {
        window.clearTimeout(id); // will do nothing if no timeout with id is present
      }
      this.$router.push({ path: "/" });
    },
    initialize() {
      this.populaCategorias();
      this.populaRecursos();
      this.populaPaises();
      this.populaEmpresas();
      this.populaClientes();
      this.populaTiposDocumentos();
      this.populaStatusDocumentos();
    },
    populaPaises() {
        apiController.request(apiController.endpoints.getallPaises, {
          onSuccess: (response) => {
            this.paises = response.data;
            this.paises.forEach(pais => {
              pais.nome = translateDbField(
                pais.translation_key,
                pais.nome
              );
              return pais;
            });
            this.checkCountry();
          },
        });
      },
    populaEmpresasPermitidas() {
      this.empresasPermitidas = this.recursos.filter((r) => r.id_empresa).map((rec) => {
        return rec.id_empresa
      });
    },
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          silent: true,
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.populaEmpresasPermitidas();
            this.populaFuncionarios();
          },
          onError: (e) => {
            console.log("Response : " + e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog = e.response.data.mensagem;
              this.autorizacaoDialog = true;
            }
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          silent: true,
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatefuncionario");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertfuncionario");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletefuncionario");
            this.populaEmpresasPermitidas();
            this.populaFuncionarios();
          },
          onError: (e) => {
            console.log("Response : " + e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog = e.response.data.mensagem;
              this.autorizacaoDialog = true;
            }
          },
        });
      }
    },
    populaFuncionarios() {
      apiController.request(apiController.endpoints.getallFuncionarios, {
        silent: true,
        onSuccess: (response) => {
          const rows = Array.isArray(response.data) ? response.data : [];
          this.funcionarios = rows;
          this.funcionarios.forEach(funcionario => {
            funcionario.categoria_extenso = translateDbField(
              funcionario.translation_key,
              funcionario.categoria_extenso
            );
          });
          this.openFromRouteQuery();
        },
        onError: (e) => {
          console.log(e);
        },
      });
    },
    openFromRouteQuery() {
      const id = this.$route && this.$route.query ? this.$route.query.id_funcionario : null;
      if (id == null || id === '') return;
      const item = (this.funcionarios || []).find((f) => String(f.id_funcionario) === String(id));
      if (!item) return;
      this.$nextTick(() => this.editItem(item));
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        silent: true,
        onSuccess: (response) => {
          this.empresas = response.data;
        },
        onError: (e) => {
          console.log(e);
        },
      });
    },
    populaClientes() {
      apiController.request(apiController.endpoints.getallClientes, {
        onSuccess: (response) => {
          this.clientes = Array.isArray(response.data) ? response.data : [];
        },
        onError: () => {
          this.clientes = [];
        },
      });
    },
    clientesPorEmpresa(idEmpresa) {
      if (idEmpresa == null) {
        return [];
      }
      return this.clientes.filter((c) => c.id_empresa === idEmpresa);
    },
    onFuncionarioEmpresaChange() {
      if (this.editedItem.id_cliente != null) {
        const stillValid = this.clientes.some(
          (c) => c.id_cliente === this.editedItem.id_cliente && c.id_empresa === this.editedItem.id_empresa
        );
        if (!stillValid) {
          this.editedItem.id_cliente = null;
        }
      }
    },
    populaTiposDocumentos() {
      apiController.request(apiController.endpoints.getTiposdocumentospessoas, {
        silent: true,
        onSuccess: (response) => {
          this.tiposDocumentos = response.data.map((t) => ({
            ...t,
            cod_tipo_documento: translateDbField(
              t.translation_key,
              t.cod_tipo_documento
            )
          }));
        },
        onError: (e) => {
          console.log(e);
        },
      });
    },
    populaStatusDocumentos() {
      apiController.request(apiController.endpoints.getallStatusdocumentos, {
        silent: true,
        onSuccess: (response) => {
          this.statusDocumentos = response.data;
          this.statusDocumentos.forEach(status => {
            status.descricao_status_documento = translateDbField(
              status.translation_key,
              status.descricao_status_documento
            );
            return status;
          });
        },
        onError: (e) => {
          console.log(e);
        },
      });
    },
    populaCategorias() {
      apiController.request(apiController.endpoints.getCategoriasfuncionarios, {
        silent: true,
        onSuccess: (response) => {
          this.categorias = response.data;
          this.categorias.forEach(categoria => {
            categoria.categoria_extenso = translateDbField(
              categoria.categoria_translation_key,
              categoria.categoria_extenso
            );
            return categoria;
          });
        },
        onError: (e) => {
          console.log(e);
        },
      });
    },
    applyScopedClienteEmpresaOnCreate() {
      this.scopedClienteCreateLocked = false;
      if (this.editedIndex !== -1 || !shouldLockClienteOnCreate()) {
        return;
      }
      const id = getScopedClienteIdForCreate();
      if (id == null) {
        return;
      }
      const c = this.clientes.find((x) => Number(x.id_cliente) === Number(id));
      if (!c || c.id_empresa == null) {
        return;
      }
      this.editedItem.id_cliente = id;
      this.editedItem.id_empresa = c.id_empresa;
      this.scopedClienteCreateLocked = true;
    },
    applySingleEmpresaIfOnlyOption() {
      if (!this.dialog || this.editedIndex !== -1) {
        return;
      }
      if (this.scopedClienteCreateLocked) {
        return;
      }
      if (this.editedItem.id_empresa != null && this.editedItem.id_empresa !== '') {
        return;
      }
      if (!Array.isArray(this.empresas) || this.empresas.length !== 1) {
        return;
      }
      this.editedItem.id_empresa = this.empresas[0].id_empresa;
      this.onFuncionarioEmpresaChange();
    },
    editItem(item) {
      this.scopedClienteCreateLocked = false;
      //this.disableEmpresa = true;
      //this.disableMatricula = true;
      //this.disableNome = true;
      //this.disableSobrenome = true;
      this.disableCPF = true;
      this.disableCNH = true;
      //this.disableCliente = true;
      //this.isCategoriaDisabled = true;
      //this.isPaisDisabled = true;
      this.editedIndex = this.funcionarios.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // Set the pais value based on editedItem.id_pais
      if (this.editedItem.id_pais) {
        this.pais = this.editedItem.id_pais;
      } else {
        // If no country is set, use default country
        const defaultPais = this.paises.find(p => p.sigla === defaultCountry);
        if (defaultPais) {
          this.pais = defaultPais.id_pais;
          this.editedItem.id_pais = defaultPais.id_pais;
        }
      }
      if (this.editedItem.ativo == 1) {
        this.isAtivo = true;
      }
      else {
        this.isAtivo = false;
      }
      this.dialog = true;
      this.$nextTick(() => this.syncUnidadeSelect());
    },
    onUnidadeSelect(val) {
      this.editedItem.id_unidade = val;
      const ref = this.$refs.unidadeSelect;
      if (ref && val != null && ref.selectedItemCache) {
        const cached = ref.selectedItemCache[val];
        if (cached) {
          if (cached.cod_unidade != null) this.editedItem.cod_unidade = cached.cod_unidade;
          if (cached.descricao_unidade != null) {
            this.editedItem.descricao_unidade = cached.descricao_unidade;
          }
        }
      } else if (val == null) {
        this.editedItem.cod_unidade = null;
        this.editedItem.descricao_unidade = null;
      }
    },
    syncUnidadeSelect() {
      const ref = this.$refs.unidadeSelect;
      if (!ref || typeof ref.setData !== 'function') return;
      const id = this.editedItem && this.editedItem.id_unidade;
      if (id != null && id !== '') {
        ref.cacheSelectedItems([{
          id_unidade: id,
          cod_unidade: this.editedItem.cod_unidade,
          descricao_unidade: this.editedItem.descricao_unidade,
        }], 'id_unidade');
        ref.setData(id);
      } else if (typeof ref.resetData === 'function') {
        ref.resetData();
      }
      if (typeof ref.loadLazyItems === 'function') {
        ref.loadLazyItems('');
      }
    },
    showUploadDialog() {
      this.arquivoCsv = null;
      this.fimProcesso = false;
      this.mensagemUpload = null;
      this.fileLoading = false;
      this.uploadDialog = true;
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog =
        this.$t('employee.confirmDelete') + " " + item.nome + " ?";
      this.showConfirmButton = true;
      this.messageDismissButton = this.$t('button.dismiss');
      this.messageConfirmButton = this.$t('button.confirm');
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      apiController.request(apiController.endpoints.deleteFuncionario, {
        data: this.deletedItem,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
      });
    },
    closeUploadDialog() {
      this.$refs.form.resetValidation();
      this.idempresaupload = null;
      this.arquivoCsv = null;
      this.uploadDialog = false;
      this.initialize();
    },
    close() {
      this.scopedClienteCreateLocked = false;
      this.disableEmpresa = false;
      this.disableMatricula = false;
      this.disableNome = false;
      this.isCategoriaDisabled = false;
      this.disableSobrenome = false;
      this.disableCPF = false;
      this.disableCNH = false;
      this.disableCliente = false;
      this.isPaisDisabled = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.isAtivo = true;
        if (this.$refs.unidadeSelect && typeof this.$refs.unidadeSelect.resetData === 'function') {
          this.$refs.unidadeSelect.resetData();
        }
        // Reset pais to default country
        const defaultPais = this.paises.find(p => p.sigla === defaultCountry);
        if (defaultPais) {
          this.pais = defaultPais.id_pais;
          this.editedItem.id_pais = defaultPais.id_pais;
        } else {
          this.pais = null;
          this.editedItem.id_pais = null;
        }
        this.$refs.form.resetValidation();
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        if (this.isAtivo) {
          this.editedItem.ativo = 1;
        }
        else {
          this.editedItem.ativo = 0;
        }

        this.editedItem.id_pais = this.pais;

        if (this.editedIndex == -1) {
          this.operacao = 0;
          apiController.request(apiController.endpoints.insertFuncionario, {
            data: this.editedItem,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        }
        else {
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateFuncionario, {
            data: this.editedItem,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        }
      }
    },
    updateTable(status) {
      if (status) {
        if (this.operacao == 0) {
          this.mensagemAlerta = this.$t('employee.alerts.error.insert');
        }
        else {
          if (this.operacao == 1) {
            this.mensagemAlerta = this.$t('employee.alerts.error.update');
          }
          else {
            this.mensagemAlerta = this.$t('employee.alerts.error.delete');
          }
        }
        this.tipoAlerta = "error";
        this.showAlert = true;
      }
      else {
        if (this.operacao == 0) {
          this.mensagemAlerta = this.$t('employee.alerts.success.insert');
        }
        else {
          if (this.operacao == 1) {
            this.mensagemAlerta = this.$t('employee.alerts.success.update');
          }
          else {
            this.mensagemAlerta = this.$t('employee.alerts.success.delete');
          }
        }
        this.tipoAlerta = "success";
        this.showAlert = true;
        this.editedItem = this.defaultItem;
      }
      this.close();
      this.initialize();
    },
    openDocumentosDialog(item) {
      this.editedItem = Object.assign({}, item);
      this.editedIndex = this.funcionarios.findIndex((f) => f.id_funcionario == item.id_funcionario);
      this.documentosDialog = true;
      this.populaDocumentosFuncionario(item.id_funcionario);
    },
    closeDocumentosDialog() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.documentosFuncionario = [];
      this.documentosDialog = false;
    },
    populaDocumentosFuncionario(idfuncionario) {
      apiController.request(apiController.endpoints.getDocumentosporidpessoa, {
        params: { id: idfuncionario },
        onSuccess: (response) => {
          this.documentosFuncionario = response.data.map((d) => ({
            ...d,
            cod_tipo_documento: translateDbField(
              d.translation_key,
              d.cod_tipo_documento
            )
          }));
        },
      });
    },
    editDocumento(doc) {
      this.editedIndexDoc = this.documentosFuncionario.indexOf(doc);
      this.editedDoc = Object.assign({}, doc);
      this.dataVencimento = this.editedDoc.dt_vencimento;
      this.addDocDialog = true;
    },
    downloadDocumento(doc) {
      const split = doc.doc_uri.split("/");
      apiController.request(apiController.endpoints.downloadDocumento, {
        params: { filename: split[split.length - 1] },
        config: { responseType: "blob" },
        onSuccess: (response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", split[split.length - 1]); //or any other extension
          document.body.appendChild(link);
          link.click();
        },
      });
    },
    closeDoc() {
      this.arquivoImg = null;
      this.docimg = null;
      this.editedIndexDoc = -1;
      this.editedDoc = Object.assign({}, this.defaultDoc);
      this.dataVencimento = null;
      this.addDocDialog = false;
      this.$nextTick(() => {
        this.$refs.formDoc.resetValidation();
      })
    },
    fileChanged() {
      const reader = new FileReader();
      reader.onload = e => {
        this.docimg = e.target.result;
      };
      reader.readAsDataURL(this.arquivoImg);
    },
    saveDoc() {
      this.$refs.formDoc.validate()
      if (this.formDocValidado) {
        this.editedDoc.dt_vencimento = this.dataVencimento;
        this.editedDoc.id_funcionario = this.editedItem.id_funcionario;
        if (this.editedIndexDoc === -1) {
          this.editedDoc.id_usuario_inclusao = this.user.id_usuario;
        } else {
          this.editedDoc.id_usuario_ultima_alteracao = this.user.id_usuario;
          this.editedDoc.dt_ultima_alteracao = DateUtils.getDateSQLFormatted(new Date());
        }

        if (this.arquivoImg) {
          let payload = {
            file: this.docimg,
            folder: "documentos",
            filename: this.arquivoImg.name.replace(".png", "").replace(".jpeg", "").replace(".jpg", "").replace(".pdf", "")
          }

              console.log(payload)
              apiController.request(apiController.endpoints.uploadImg, {
                data: payload,
                onSuccess: (response) => {
                  console.log(response.data);
                  if (!response.data.erro) {
                    this.editedDoc.doc_uri = response.data.path;
                  }
                  this.saveOnDatabase();
                },
                onError: () => {
                  // Continua salvando mesmo com erro no upload da imagem
                  this.saveOnDatabase();
                },
              });
            } else {
              this.saveOnDatabase();
            }
          }
        },
        saveOnDatabase() {
          apiController.request(apiController.endpoints.insertDocumentopessoa, {
            data: this.editedDoc,
            onSuccess: (response) => {
              console.log(response.data);
              this.populaDocumentosFuncionario(this.editedItem.id_funcionario);
              this.closeDoc();
            },
            onError: () => {
              this.closeDoc();
            },
          });
        },
        validaCPF(){
          const cpf = this.editedItem.cpf;
          const falsos = [ '00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999']
          let soma = 0;
          let resto;

      if (cpf == null) return this.$t('employee.cpfRequired');

      if (cpf.length !== 11) return this.$t('employee.invalidCpf');

      if (falsos.indexOf(cpf) !== -1) return this.$t('employee.invalidCpf');

      for (let i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;

      if ((resto == 10) || (resto == 11)) resto = 0;
      if (resto != parseInt(cpf.substring(9, 10))) return this.$t('employee.invalidCpf');

      soma = 0;
      for (let i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;

      if ((resto == 10) || (resto == 11)) resto = 0;
      if (resto != parseInt(cpf.substring(10, 11))) return this.$t('employee.invalidCpf');
      return true;
    },
    validaCNH() {
      return true;
    },
    validaDocumentoIdentidade() {
      if (this.editedItem.cpf === null || this.editedItem.cpf === '') {
        return true;
      }
      // Se não há país selecionado, usa validação de CPF por padrão
      if (!this.pais) {
        return this.validaCPF();
      }

      // Busca o país selecionado
      const paisSelecionado = this.paises.find(p => p.id_pais === this.pais);
      
      // Se o país for México (id_pais = 2 ou sigla = 'MX'), valida CURP
      if (paisSelecionado && (paisSelecionado.id_pais === 2 || paisSelecionado.sigla === 'MX')) {
        return this.validaCURP();
      }
      
      // Para Brasil ou outros países, valida CPF
      return this.validaCPF();
    },
    checkCountry() {
        const defaultPais = this.paises.find(p => p.sigla === defaultCountry);
        if (defaultPais) {
          this.pais = defaultPais.id_pais;
          this.editedItem.id_pais = defaultPais.id_pais;
        }
      },
    saveBulk(func) {
      if (func.length > 0) {
        apiController.request(apiController.endpoints.upsertFuncionariosbulk, {
          data: func,
          silent: true,
          onSuccess: (response) => {
            this.uploadResultDialog = false;
            this.updateTable(response.data.erro);
          },
          onError: (e) => {
            this.uploadResultDialog = false;
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                this.$t('system.messages.accessDenied');
              this.autorizacaoDialog = true;
            }
          },
        });
      }
    },
    handleDone(data) {
      this.zipResult = {
        error: false,
        message: data.message || this.$t('crudUsuarios.messages.fileProcessedSuccess'),
        messages: data.messages || [],
        processedFiles: data.processedFiles || 0
      };
      this.zipResultDialog = true;
    },
    handleError(data) {
      console.log("handleError", data);
      this.zipResult = {
        error: true,
        message: data.message || data.error || this.$t('employee.alerts.error.zip'),
        messages: []
      };
      this.zipResultDialog = true;
    },
    closeZipResultDialog() {
      this.zipResultDialog = false;
      this.zipResult = null;
    },

    validaCURP() {
      const curpString = this.editedItem.cpf;
      
      if (curpString == null) return this.$t('employee.cpfRequired');

      if (curpString.length !== 18) return this.$t('employee.invalidCpf');

      const isValid = curp.validar(curpString);
      if (!isValid) return this.$t('employee.invalidCpf');

      return true;
    },
  },
  components: { CadastroToolbar, MerusDataTable, UploadDialog, ResultDialogZIP, LazySelect }
};
</script>
